import { Image } from '@/components/Image'
import { Link } from '@/components/Link'
import { WidgetBannerProps } from '@/types/cms'
import styles from './BannerDefault.module.scss'

export default function BannerDefault({ item }: Readonly<{ item: WidgetBannerProps }>) {
  const image = item.model.image
  const link = item.model.fields.link

  const bannerImage = <Image image={image} alt={image.filename} />

  return link?.url ? (
    <Link href={link.url} target={link.target === '_blank' ? 'blank' : undefined} className={styles.banner}>
      {bannerImage}
    </Link>
  ) : (
    <div className={styles.banner}>{bannerImage}</div>
  )
}
